import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=20831e22&scoped=true&"
import script from "./IconSelector.vue?vue&type=script&lang=js&"
export * from "./IconSelector.vue?vue&type=script&lang=js&"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=20831e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20831e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20831e22')) {
      api.createRecord('20831e22', component.options)
    } else {
      api.reload('20831e22', component.options)
    }
    module.hot.accept("./IconSelector.vue?vue&type=template&id=20831e22&scoped=true&", function () {
      api.rerender('20831e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/IconSelector.vue"
export default component.exports